import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Link,
    List,
    ListItem,
    Typography
} from "@mui/material";

import { useIssues } from "./contexts/IssuesContextProvider";

export type ViewEstimatesModalProps = {
    issueId: string;
    open: boolean;
    onClose: () => void;
}

export const ViewEstimatesModal = (props: ViewEstimatesModalProps) => {
    const { open, onClose, issueId } = props;

    const { issueIdToIssueMap } = useIssues();

    const issue = issueIdToIssueMap.get(issueId);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                Estimates
            </DialogTitle>
            <DialogContent>
                {issue && (issue.proposalDocLinks ?? []).length > 0 ? (
                    <List>
                        {(issue.proposalDocLinks ?? [])
                            .sort((a, b) => b.date - a.date)
                            .map((link, id) => (
                                <ListItem
                                    key={`${link.name}-${id}`}
                                    divider
                                    sx={{
                                        display: "flex",
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: "space-between",
                                        paddingY: 2,
                                    }}
                                >
                                    <Link
                                        href={link.link.startsWith("http") ? link.link : `https://${link.link}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            {link.name}
                                        </Typography>
                                    </Link>
                                    <Typography variant="body2" color="text.secondary">
                                        {new Date(link.date).toLocaleDateString()}
                                    </Typography>
                                </ListItem>
                            ))}
                    </List>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        No estimates available
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};